module.exports = __webpack_public_path__ + "Sample-Import-User-Promo.xlsx";